import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import PageLayout from '@/components/layout/page-layout'
import CommunicationTemplatesPage from '@/components/organisms/communication-templates'
import { PermissionsUtils } from '@/utils/permissions.utils'

export const Route = createFileRoute('/_authenticated/communication-templates')({
  component: CommunicationTemplatesRoute,
})

function CommunicationTemplatesRoute() {
  const { t } = useTranslation()

  if (!PermissionsUtils.hasPermission('communication-templates:read')) return null

  return (
    <PageLayout title={t('communicationTemplates.page.title')}>
      <CommunicationTemplatesPage />
    </PageLayout>
  )
}
